
import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function PricingSection() {
  const [selectedCategory, setSelectedCategory] = useState('individual');

  const individualServices = [
    {
      name: 'Massage Découverte',
      duration: '45 min',
      price: '65€',
      description: 'Parfait pour découvrir nos services',
      features: ['Massage relaxant', 'Consultation personnalisée', 'Conseils bien-être'],
      popular: false
    },
    {
      name: 'Massage Bien-être',
      duration: '60 min',
      price: '80€',
      description: 'Notre service le plus demandé',
      features: ['Massage au choix', 'Aromathérapie incluse', 'Tisane détox offerte'],
      popular: true
    },
    {
      name: 'Massage Thérapeutique',
      duration: '75 min',
      price: '95€',
      description: 'Pour les besoins spécifiques',
      features: ['Massage deep tissue', 'Consultation approfondie', 'Suivi personnalisé'],
      popular: false
    },
    {
      name: 'Soin Complet Premium',
      duration: '90 min',
      price: '120€',
      description: 'L\'expérience ultime de détente',
      features: ['Massage + soin visage', 'Pierres chaudes', 'Espace détente privé'],
      popular: false
    }
  ];

  const packages = [
    {
      name: 'Forfait Découverte',
      sessions: '3 séances',
      price: '210€',
      originalPrice: '240€',
      description: 'Idéal pour commencer votre parcours bien-être',
      features: ['3 massages 60min', 'Flexibilité totale', 'Valable 3 mois'],
      popular: false
    },
    {
      name: 'Forfait Bien-être',
      sessions: '5 séances',
      price: '350€',
      originalPrice: '400€',
      description: 'Le meilleur rapport qualité-prix',
      features: ['5 massages au choix', 'Séance bonus offerte', 'Valable 6 mois'],
      popular: true
    },
    {
      name: 'Forfait Premium',
      sessions: '10 séances',
      price: '650€',
      originalPrice: '800€',
      description: 'Pour un suivi régulier optimal',
      features: ['10 massages premium', '2 séances bonus', 'Priorité réservation'],
      popular: false
    }
  ];

  const homeServices = [
    {
      name: 'Massage à Domicile',
      duration: '60 min',
      price: '120€',
      description: 'Confort de votre domicile',
      features: ['Déplacement inclus', 'Matériel fourni', 'Zone Pointe-à-Pitre'],
      popular: false
    },
    {
      name: 'Forfait Couple Domicile',
      duration: '60 min',
      price: '220€',
      description: 'Moment privilégié à deux',
      features: ['2 massages simultanés', 'Ambiance romantique', 'Champagne offert'],
      popular: true
    },
    {
      name: 'Séance Famille',
      duration: '90 min',
      price: '180€',
      description: 'Détente pour toute la famille',
      features: ['Jusqu\'à 4 personnes', 'Techniques adaptées', 'Moment de partage'],
      popular: false
    }
  ];

  const getCurrentServices = () => {
    switch (selectedCategory) {
      case 'packages': return packages;
      case 'home': return homeServices;
      default: return individualServices;
    }
  };

  const scrollToReservation = () => {
    const element = document.getElementById('reservation');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="tarifs" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            <strong>Tarifs</strong> Massages <strong>Guadeloupe</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Des <strong>tarifs transparents</strong> pour tous nos services de <strong>bien-être</strong> 
            et <strong>massages thérapeutiques</strong> en Guadeloupe.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row justify-center mb-12">
          <div className="bg-gray-100 rounded-full p-1 flex">
            <button
              onClick={() => setSelectedCategory('individual')}
              className={`px-6 py-2 rounded-full transition-all cursor-pointer whitespace-nowrap ${
                selectedCategory === 'individual'
                  ? 'bg-purple-400 text-white shadow-md'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              Services Individuels
            </button>
            <button
              onClick={() => setSelectedCategory('packages')}
              className={`px-6 py-2 rounded-full transition-all cursor-pointer whitespace-nowrap ${
                selectedCategory === 'packages'
                  ? 'bg-purple-400 text-white shadow-md'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              Forfaits
            </button>
            <button
              onClick={() => setSelectedCategory('home')}
              className={`px-6 py-2 rounded-full transition-all cursor-pointer whitespace-nowrap ${
                selectedCategory === 'home'
                  ? 'bg-purple-400 text-white shadow-md'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              À Domicile
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {getCurrentServices().map((service, index) => (
            <div
              key={index}
              className={`relative bg-white rounded-xl shadow-lg border-2 transition-all duration-300 hover:shadow-xl hover:-translate-y-2 ${
                service.popular ? 'border-purple-400' : 'border-gray-200'
              }`}
            >
              {service.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <span className="bg-purple-400 text-white px-4 py-1 rounded-full text-sm font-medium">
                    Plus Populaire
                  </span>
                </div>
              )}
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{service.name}</h3>
                <p className="text-gray-600 mb-4">{service.description}</p>
                
                <div className="mb-4">
                  <div className="flex items-baseline">
                    <span className="text-3xl font-bold text-purple-600">{service.price}</span>
                    {service.originalPrice && (
                      <span className="ml-2 text-lg text-gray-400 line-through">
                        {service.originalPrice}
                      </span>
                    )}
                  </div>
                  <p className="text-gray-500 text-sm">
                    {service.duration || service.sessions}
                  </p>
                </div>
                
                <ul className="space-y-2 mb-6">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-600">
                      <i className="ri-check-line text-purple-400 mr-2"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
                
                <Button
                  fullWidth
                  variant={service.popular ? 'primary' : 'outline'}
                  onClick={scrollToReservation}
                >
                  Réserver Maintenant
                </Button>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-purple-400 to-purple-600 rounded-2xl p-8 md:p-12 text-white text-center">
          <h3 className="text-3xl font-bold mb-4">
            Offre Spéciale Première Visite
          </h3>
          <p className="text-xl mb-6 opacity-90">
            <strong>-20% sur votre premier massage</strong> + consultation bien-être gratuite
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              variant="secondary"
              size="lg"
              onClick={scrollToReservation}
            >
              <i className="ri-gift-line mr-2"></i>
              Profiter de l'Offre
            </Button>
            <Button
              variant="outline"
              size="lg"
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-white/10 backdrop-blur-sm border-white text-white hover:bg-white hover:text-gray-900"
            >
              <i className="ri-question-line mr-2"></i>
              En Savoir Plus
            </Button>
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">
            <strong>Moyens de paiement acceptés :</strong>
          </p>
          <div className="flex justify-center items-center space-x-6 text-gray-400">
            <i className="ri-bank-card-line text-2xl"></i>
            <i className="ri-money-euro-circle-line text-2xl"></i>
            <i className="ri-smartphone-line text-2xl"></i>
            <span className="text-sm">Chèques cadeaux disponibles</span>
          </div>
        </div>
      </div>
    </section>
  );
}
